// Aereo: comportamiento de la colección (columna de filtros, barra móvil, orden y swatches de las tarjetas).
// La lógica de filtrar y recargar la grilla sigue en navigation.js; aquí solo se conecta la interfaz nueva.
(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');

  const handle = (text) =>
    text.handleize ? text.handleize() : text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  // Pinta los círculos de color de filtros y tarjetas con la configuración de swatches del theme
  const paintSwatches = (scope = document) => {
    const swatches = (window.theme && theme.swatches) || {};
    scope.querySelectorAll('.filter--dot[data-swatch], .product--swatch[data-swatch]').forEach((el) => {
      if (el.dataset.painted) return;
      const key = handle(el.dataset.swatch);
      const value = swatches[key];
      if (value && CSS.supports('color', value)) el.style.backgroundColor = value;
      else if (value) el.style.backgroundImage = `url(${value})`;
      else if (CSS.supports('color', key)) el.style.backgroundColor = key;
      el.dataset.painted = 'true';
    });
  };

  // En desktop los grupos de filtros arrancan abiertos (Categorías cerrado), como en el live
  const openSidebarGroups = () => {
    const sidebar = document.querySelector('[data-collection-sidebar]');
    if (!sidebar || !desktop.matches || sidebar.dataset.opened) return;
    sidebar.querySelectorAll('.filter--toggle').forEach((toggle) => {
      const open = (toggle.getAttribute('aria-controls') || '').endsWith('-refine-filter');
      toggle.setAttribute('aria-expanded', open);
      toggle.nextElementSibling && toggle.nextElementSibling.setAttribute('data-transition-active', open);
    });
    sidebar.dataset.opened = 'true';
  };

  // Encabezado de la hoja de filtros en celular (barra para arrastrar, título y cerrar)
  const sheetHead = () => {
    const container = document.querySelector('.drawer--instance[data-side="right"] .drawer--container[data-view="filter"]');
    if (!container || container.querySelector('.aereo-sheet-head')) return;
    const head = document.createElement('div');
    head.className = 'aereo-sheet-head';
    head.innerHTML = '<i aria-hidden="true"></i><b>Filtrar</b><button type="button" aria-label="Cerrar filtros">' + CLOSE_ICON + '</button>';
    head.querySelector('button').addEventListener('click', () => theme.drawer.close());
    container.prepend(head);
  };

  const CLOSE_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>';

  // Hoja para ordenar en celular: lista las opciones del selector y al elegir usa el mismo flujo del selector
  const sortSheet = (sort_select, sort_button) => {
    let sheet = document.querySelector('[data-aereo-sort-sheet]');
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'aereo-sort-sheet';
      sheet.setAttribute('data-aereo-sort-sheet', '');
      sheet.innerHTML =
        '<div class="aereo-sort-sheet__scrim" data-close></div>' +
        '<div class="aereo-sort-sheet__panel" role="dialog" aria-modal="true" aria-label="Ordenar por">' +
        '<div class="aereo-sheet-head"><i aria-hidden="true"></i><b>Ordenar por</b><button type="button" data-close aria-label="Cerrar">' + CLOSE_ICON + '</button></div>' +
        '<ul class="aereo-sort-sheet__list"></ul></div>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', (event) => {
        const option = event.target.closest('[data-value]');
        if (option) {
          sort_select.value = option.dataset.value;
          sort_select.dispatchEvent(new Event('change'));
          sort_button.querySelector('[data-collection-sort-current]').textContent = option.textContent;
        }
        if (option || event.target.closest('[data-close]')) close();
      });
      document.addEventListener('keydown', (event) => event.key === 'Escape' && sheet.classList.contains('is-open') && close());
    }
    const close = () => {
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('aereo-sheet-open');
      sort_button.focus();
    };
    sheet.querySelector('ul').innerHTML = [...sort_select.options]
      .map((o) => `<li><button type="button" data-value="${o.value}" aria-pressed="${o.value === sort_select.value}">${o.textContent.trim()}</button></li>`)
      .join('');
    document.documentElement.classList.add('aereo-sheet-open');
    void sheet.offsetHeight; // arranca abajo y sube con la transición
    sheet.classList.add('is-open');
    const current = sheet.querySelector('[aria-pressed="true"]') || sheet.querySelector('[data-value]');
    current && current.focus({ preventScroll: true });
  };

  const initToolbar = () => {
    // "Filtrar" abre los filtros. En celular salen en una hoja desde abajo con todos los grupos abiertos;
    // en tablet, el drawer de la derecha con Talla abierta, como antes.
    const filter_button = document.querySelector('[data-collection-filter-button]');
    filter_button &&
      filter_button.addEventListener('click', () => {
        const sheet = window.matchMedia('(max-width: 767px)').matches;
        document.querySelectorAll('.filter--root .filter--toggle').forEach((toggle) => {
          const controls = toggle.getAttribute('aria-controls') || '';
          const open = sheet ? controls.endsWith('-refine-filter') : controls === 'talla-refine-filter';
          toggle.setAttribute('aria-expanded', open);
          toggle.nextElementSibling && toggle.nextElementSibling.setAttribute('data-transition-active', open);
        });
        if (sheet) {
          sheetHead();
          // La vista se marca antes de abrir para que la hoja arranque abajo y no entre desde la derecha
          const viewport = theme.drawer.viewport;
          viewport.setAttribute('data-drawer-view', 'filter');
          viewport.setAttribute('data-drawer-side', 'right');
          void theme.drawer.offsetHeight;
        }
        theme.drawer.open('right', 'filter', filter_button);
      });

    // El selector de orden usa las mismas opciones del formulario de filtros
    const sort_select = document.querySelector('[data-collection-sort]');
    sort_select &&
      sort_select.addEventListener('change', () => {
        const input = document.querySelector(`.filter--root input[name="sort_by"][value="${CSS.escape(sort_select.value)}"]`);
        if (input && !input.checked && input.nextElementSibling) input.nextElementSibling.click();
      });

    const sort_button = document.querySelector('[data-collection-sort-button]');
    sort_select && sort_button && sort_button.addEventListener('click', () => sortSheet(sort_select, sort_button));
  };

  // Swatches de las tarjetas: cambian la foto y el enlace a la variante sin abrir el producto
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.product--swatch');
    if (!swatch) return;
    event.preventDefault();
    const card = swatch.closest('.product--root');
    const image = card && card.querySelector('.product--image img');
    if (image && swatch.dataset.image) {
      image.srcset = swatch.dataset.srcset || '';
      image.src = swatch.dataset.image;
    }
    const link = card && card.querySelector('a[href]');
    if (link && swatch.dataset.url) link.href = swatch.dataset.url;
    card.querySelectorAll('.product--swatch').forEach((el) => el.setAttribute('aria-pressed', el === swatch));
  });

  const init = () => {
    paintSwatches();
    openSidebarGroups();
    initToolbar();
  };

  window.on && window.on('theme:navigation:filterPlaced', () => (paintSwatches(), openSidebarGroups()));
  window.on && window.on('theme:navigation:reloaded', () => paintSwatches());
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
